/**
 * Revela una sola vez los elementos con [data-oj-revela] cuando entran en pantalla.
 *
 * Al cargar, los que todavía están fuera de la vista pasan a data-oj-revela="pendiente" (el CSS los
 * deja sin dibujar) y, al entrar, a "visto" (el CSS los anima). Los que ya están a la vista, los que
 * llegan después (re-render del editor) y todos con movimiento reducido o sin JavaScript se quedan en
 * su estado final, sin animación.
 */
const elementos = [...document.querySelectorAll('[data-oj-revela=""]')];
const movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (elementos.length && !movimientoReducido && 'IntersectionObserver' in window) {
  const observador = new IntersectionObserver(
    (entradas) => {
      for (const entrada of entradas) {
        if (!entrada.isIntersecting) continue;
        entrada.target.setAttribute('data-oj-revela', 'visto');
        observador.unobserve(entrada.target);
      }
    },
    { threshold: 0.35 }
  );

  for (const elemento of elementos) {
    const caja = elemento.getBoundingClientRect();
    const aLaVista = caja.top < window.innerHeight && caja.bottom > 0;
    if (aLaVista) continue;
    elemento.setAttribute('data-oj-revela', 'pendiente');
    observador.observe(elemento);
  }
}
